//Утилита, которая принимает на вход число и возвращает его кратным миллиону

const editPriceInMillions = num => {
  return num / 1000000;
};

export default editPriceInMillions;
